export default __webpack_public_path__ + "static/media/avatar.32c4173b.png";